import *  as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk'
import { output } from '../js/FormatOutput'

export interface FileWithReco {
  fileName: string
  reco: SpeechSDK.SpeechRecognizer
}

export const filePickerChange = (
  files: File[] | null,
  setContinousRecognitionDisabled: any,
  subscriptionKeyValue: string,
  serviceRegion: string,
  languageOptions: string,
) => {


  let fileRecos: FileWithReco[] = []

  setContinousRecognitionDisabled(true)
  let audioConfig;

  const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(subscriptionKeyValue, serviceRegion);
  speechConfig.speechRecognitionLanguage = languageOptions;


  Array.from(files ? files : []).forEach((file: File) => {
    audioConfig = SpeechSDK.AudioConfig.fromWavFileInput(file);
    const file_reco = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
    fileRecos.push({ fileName: file.name, reco: file_reco })
  })

  return fileRecos;
}

export const recognize = (namedRecos: FileWithReco[], out: string, media_format: string,
  setTranscribing: any, setTranscriptionFinished: any, setData: any, total_length: number) => {
  let allPhrases: string[] = ['Text,Onset,Offset\n'];
  let current_progress = -1;
  let finishedRecos = 0;
  let progressDict: {[key: string]: any} = {};

  namedRecos.forEach(async ({ fileName, reco }) => {
    progressDict[fileName] = 0;
    // The event recognized signals that a final recognition result is received.
    // This is the final event that a phrase has been recognized.
    // For continuous recognition, you will get one recognized event for each phrase recognized.
    reco.recognized = (s: SpeechSDK.Recognizer, e: SpeechSDK.SpeechRecognitionEventArgs) => {
      // Indicates that recognizable speech was not detected, and that recognition is done.
      if (e.result.reason === SpeechSDK.ResultReason.NoMatch) {
        const noMatchDetail = SpeechSDK.NoMatchDetails.fromResult(e.result);
        console.log(`noMatchDetail is ${noMatchDetail}`)
      }
      //Manipulation of output
      console.log(e.result);
      let timeStart = parseInt(fileName.replace('.wav', ''));
      if (isNaN(timeStart)) {
        timeStart = 0;
      }
      const text = e.result.text;
      const noPunctuation = text.replace(/[.,/#!$?%^&*;:{}=\-_`~()"]/g, "");
      const finalText = noPunctuation.replace(/\s{2,}/g, " ");
      const onset = (e.result.offset / 10000000) + timeStart;
      const offset = (e.result.duration / 10000000) + onset;
      progressDict[fileName] = offset - timeStart;
      let phrase = finalText + ',' + onset + ',' + offset + '\n';
      allPhrases.push(phrase);
      var current_length = 0.0;
      for (const [key, value] of Object.entries(progressDict)) {
          current_length += value;
      }
      if (Math.round(current_length / total_length * 100) > current_progress) {
        current_progress = Math.round(current_length / total_length * 100);
        let button = document.getElementById('transcriptionButton');
        if (button !== null) {
          button.innerText = "Transcribing... (" + current_progress + "%)";
        }
      }
    }

    // The event signals that the service has stopped processing speech.
    // https://docs.microsoft.com/javascript/api/microsoft-cognitiveservices-speech-sdk/speechrecognitioncanceledeventargs?view=azure-node-latest
    // This can happen for two broad classes of reasons.
    // 1. An error is encountered.
    //    In this case the .errorDetails property will contain a textual representation of the error.
    // 2. Speech was detected to have ended.
    //    This can be caused by the end of the specified file being reached, or ~20 seconds of silence from a microphone input.
    reco.canceled = function (s, e) {
      if (e.reason === SpeechSDK.CancellationReason.Error) {
        if (e.errorDetails.includes('StatusCode: 1006')) {
          alert('HTTP Authentication failed; no valid credentials available.\n\nThis usually indicates that either your API key is invalid or it is for a different region than you have selected.');
        }
      }
    };


    // Signals the end of a session with the speech service.
    reco.sessionStopped = function (s, e) {
      finishedRecos++;
      if (finishedRecos === namedRecos.length) {
        allPhrases.sort( (a: string, b: string) => 
        {
          var a_stamp = a.split(',')[1];
          var b_stamp = b.split(',')[1];
          var a_val = a_stamp === 'Onset' ? -1 : parseFloat(a_stamp);
          var b_val = b_stamp === 'Onset' ? -1 : parseFloat(b_stamp);
          return a_val - b_val;
        });
        setTranscribing(false);
        setTranscriptionFinished(true);
        setData(allPhrases);
        var button = document.getElementById('transcriptionButton');
        var select = document.getElementById('filePicker');
        var finished = document.getElementById('finishedTranscriptionText');
        var outputFormat = document.getElementById('outputFormat')  as HTMLInputElement;
        if (button !== null && select !== null && finished !== null && outputFormat !== null) {
          button.innerText = "Download again";
          finished.style.visibility = "visible";
          select.removeAttribute('disabled');
          output(allPhrases, out, media_format, outputFormat.value, total_length);
        }
      }
    };

    // Signals that the speech service has started to detect speech.
    reco.speechStartDetected = function (s, e) {

    };

    // Signals that the speech service has detected that speech has stopped.
    reco.speechEndDetected = function (s, e) {

    };

    reco.startContinuousRecognitionAsync();
  });
}